import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/services-shape-2.png'


const _hoisted_1 = { class: "services-area-three ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "position-relative z-1 shape-wrap" }
const _hoisted_6 = { class: "services-single-item-three hover-style1" }
const _hoisted_7 = { class: "hover-style2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "section-title text-center m-auto",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("span", { class: "top-title" }, "خدماتنا"),
        _createElementVNode("h2", null, "كل ما تحتاجه لترفيه متكامل")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: service.id,
            class: "col-lg-4 col-sm-6",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": 200 + index * 100
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("i", {
                    class: _normalizeClass([service.icon, "icon"])
                  }, null, 2),
                  _createElementVNode("h3", null, [
                    _createVNode(_component_RouterLink, { to: "/services-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(service.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(service.description), 1),
                  _createVNode(_component_RouterLink, {
                    to: "/services-details",
                    class: "read-more style-two text-grey-teal"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" المزيد ", -1),
                      _createElementVNode("i", { class: "ti ti-arrow-right" }, null, -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_0,
                class: "services-shape d-none d-xl-block",
                alt: "services-shape"
              }, null, -1))
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}